// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"52":"consultation","93":"reimbursement","783":"labs"}[chunkId] || chunkId) + "." + {"12":"2289a78f","36":"dd121c7a","52":"fc83da08","93":"4ba80d01","144":"456cec94","277":"49459fbb","366":"f4607046","522":"69aef574","624":"b272bd48","783":"65af0d44","837":"10e89095"}[chunkId] + ".chunk.js";
};